<script>
    import Vue from "vue";
    import utils from "@/utils.js";

    export default {
        name: "ChangePassphrase",
        data() {
            return {
                prevPass: "",
                errorMessage: "",
                phase: "verify-pass",
            };
        },
        methods: {
            cancel() {
                this.$store.commit("go", "passwords");
            },
            passChosen(newPass) {
                this.$store
                    .dispatch("updatePassPhrase", {
                        prevPass: this.prevPass,
                        newPass: newPass,
                    })
                    .then(() => {
                        this.$store.dispatch("logOut");
                    });
            },

            downloadPreChange() {
                console.log("banaaaaaaaaaaaan");
                this.verifyPass(this.prevPass)
                    .then(() => {
                        this.$store.dispatch("exportJSON");
                        this.phase = "pick-new-pass";
                    })
                    .catch(error => {
                        if (error == "pass_mismatch") {
                            this.errorMessage = "The typed in master passphrase doesn't seem to match the current one.";
                        }
                    });
            },

            async verifyPass(pass) {
                return new Promise((resolve, reject) => {
                    this.$store
                        .dispatch("hashOnServer", {pass})
                        .then(hashedPass => {
                            let matches = hashedPass == this.$store.state.hashedPass;
                            if (matches) {
                                resolve();
                            } else {
                                reject("pass_mismatch");
                            }
                        })
                        .catch(error => {
                            reject(error);
                        });
                });
            },
        },

        mounted() {
            this.$refs.prevPass.focus();
        },
    };
</script>


<template>
    <plain-page class="change-master-pass">
        <template #header>
            <LogoBox section="Change Passphrase" />
        </template>

        <div class="verify-and-download" v-if="phase == 'verify-pass'">
            <p>
                Changing your master passphrase can be a risky endevour as, while the old one might be well wired in
                your brain, a new passphrase will take some time to cement in (take it from someone who has locked
                themselves out a few times).
            </p>

            <p>
                For that reason, part of the master passphrase changing, is downloading all your current passwords, so
                that you don't lock yourself out. Don't save the password file on a device that you can't trust, though.
            </p>

            <form class="prev-pass" @submit.prevent="downloadPreChange">
                <input
                    type="password"
                    v-model="prevPass"
                    ref="prevPass"
                    placeholder="Your Current Passphrase"
                    @input="errorMessage = ''"
                />
                <div class="message-and-buttons">
                    <div class="error">
                        {{ errorMessage }}
                    </div>

                    <div>
                        <div class="buttons">
                            <button type="submit" class="btn accent">
                                Download Passwords
                            </button>
                            <button class="btn" @click="cancel">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div v-if="phase == 'pick-new-pass'">
            <p class="note">
                The download was just triggered, so don't forget to put the file in a safe place. We're moving onwards
                to picking a new master passpack though!
            </p>

            <safe-passphrase-picker @on-chosen="passChosen" />
        </div>
    </plain-page>
</template>


<style lang="scss">
    .change-master-pass {
        .logo-box {
            margin-left: -70px;
            font-size: 18px;

            gap: 0px 15px;

            .section {
                font-size: 12px;
            }

            svg {
                width: 55px;
            }
        }

        display: flex;
        height: 100%;
        flex-direction: column;

        .contents {
            max-width: 50em;
            margin: 0 auto;
            padding: 2em;
            line-height: 150%;
            flex-grow: 1;
        }

        .note {
            margin: 2em 0;
        }

        .error {
            color: red;
            padding-bottom: 0.5em;
            font-size: 0.85em;
        }

        .prev-pass {
            input {
                width: 100%;
                margin-bottom: 15px;
            }

            .buttons {
                display: inline-flex;
                flex-direction: row-reverse;
            }
        }

        .message-and-buttons {
            display: grid;
            grid-template-columns: 1fr auto;
        }
    }
</style>


